import SearchArea from './searchArea';
import SearchLocation from './searchLocation';

export default class App {
  constructor(appName) {
    this.appName = appName;
  }

  init() {
    this.serchLocation = new SearchLocation();
    this.serchLocation.init();

    this.serchArea = new SearchArea();
    this.serchArea.init();
  }
}
